module.exports = __webpack_public_path__ + "static/media/hiv_in_women.81ea6268.jpg";